import httpClient, { ApiError } from '../../utilities/httpClient';
import { ToastMan } from '../../utilities/toastMan';
/**
 * Renders the Google Identity Services button on the login page and, on a successful credential,
 * POSTs the Google ID token to /login/google (the server exchanges it for a session). No-ops when
 * the button or a client id isn't present.
 */
export class GoogleSignIn {
    static init() {
        const mount = document.getElementById('googleSignInButton');
        if (!mount)
            return;
        const clientId = mount.getAttribute('data-client-id');
        if (!clientId)
            return;
        GoogleSignIn.render(mount, clientId, 0);
    }
    /** GIS loads async, so poll briefly for it before rendering the button. */
    static render(mount, clientId, attempts) {
        const gid = window.google?.accounts?.id;
        if (!gid) {
            if (attempts > 50)
                return; // ~5s — GIS script never loaded; leave the page as-is
            window.setTimeout(() => GoogleSignIn.render(mount, clientId, attempts + 1), 100);
            return;
        }
        gid.initialize({ client_id: clientId, callback: GoogleSignIn.onCredential });
        // Match the full-width green "Continue" button above. Google caps the button at 400px, so
        // clamp to that; fall back to 384 if the mount isn't laid out yet.
        const width = Math.min(mount.offsetWidth || 384, 400);
        gid.renderButton(mount, { type: 'standard', theme: 'outline', size: 'large', text: 'continue_with', width });
    }
    static async onCredential(response) {
        if (!response.credential)
            return;
        try {
            await httpClient.post('/login/google', { credential: response.credential });
            window.location.href = '/dashboard';
        }
        catch (error) {
            // Show the server's actual reason (e.g. "you already have an account with this email —
            // sign in with email or phone") rather than a misleading "try again".
            const message = error instanceof ApiError ? error.message : 'Google sign-in failed. Please try again.';
            ToastMan.show({ message, type: 'error', duration: 6000 });
        }
    }
}
